export default {
  title: 'Support Kontaktieren',
  form: {
    firstName: 'Name',
    lastName: 'Nachname',
    nickname: 'Nickname',
    phoneNumber: 'Handynummer',
    email: 'E-Mail',
    emailVerification: 'E-Mail Verifizierung',
    subject: {
      label: 'Betreff',
      options: ['Fehler', 'Rechnung', 'Verbindung', 'Feedback', 'Verbesserung'],
    },
    message: 'Nachricht',
    button: 'Schicken',
  },
  errors: {
    requiredField: 'Pflichtfeld.',
    sendFailed: 'Einer unserer Support-Mitarbeiter wird Ihnen in Kürze antworten',
  },
  success: {
    title: 'Verstanden!',
    message: 'Einer unserer Support-Mitarbeiter wird Ihnen in Kürze antworten.',
  },
};
